export const contactsData = {
    email: 'esperance.ahouissou@epitech.eu',
    phone: '+229 01 53 93 85 44',
    // address: 'Menlo Park, California, United States - 673822 ',

    sheetAPI: ''
}